<template>
  <div>
    <v-menu
      open-on-hover
      bottom
      right
      origin="center center"
      transition="slide-y-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          icon
          v-on="on"
        >
          <v-icon color="primary">
            mdi-filter-variant
          </v-icon>
        </v-btn>
      </template>

      <v-list
        class="filter-list"
        dense
      >
        <v-list-item
          v-for="item in filters"
          id=""
          :key="item.value"
          :class="{ selected: item.value === status }"
          @click="filter(item.value)"
        >
          <v-list-item-title>{{ item.name }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "FilterList",
  props: {
    status: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      filters: [
        { id: 1, name: "All", value: "" },
        { id: 2, name: "Active", value: "1" },
        { id: 3, name: "Inactive", value: "2" }
      ]
    };
  },
  methods: {
    filter(v) {
      this.$emit("change", v);
    }
  }
};
</script>

<style scoped>
.filter-list .selected {
  background-color: #d37c71;
  color: white;
}
</style>